const { post } = require("jquery");

jQuery(function($) {
  // Filtering for CPTs
  // Bind our Select action to the main container
  $('.category_filter__links li a').on('click', function(e) {
    e.preventDefault();

    // Let's start moving the user to the top of the page now while the query goes down
    scroll_to_posts();

    // Saving dem brackets
    $this = $(this);

    // First we need to remove existing 'selected' attributes, then add selected to changed Option
    // This allows us to know which Taxonomy & Term we can grab for pagination
    $('.category_filter__links li').removeClass("active-term");
    $(this).parent("li").addClass("active-term");
    $this = $(".category_filter__links li.active-term");

    // Build our query parameters from our selected Option
    $params = {
      tax: $('#ajax-container').data('tax'),
      term: $(this).parent('li').data('term'),
      page: $('#ajax-container').data('page'),
      post_type: $('#ajax-container').data('post-type'),
      qty: $('#ajax-container').data('paged')
    };

    // Run query
    get_posts($params);
  });

  // Bind our pagination link
  bind_pagination();

  function scroll_to_posts() {
    $('html, body').animate({ 
      scrollTop: $('#ajax-container').offset().top-180 },
      150,
      "linear"
    )
  }

  // This is our main AJAX function, some micro copy for status will be edited here
  function get_posts($params) {
    $container = $("#ajax-container");
    $content = $container.find(".ajax-content");
    $status = $container.find(".status");
    
    $.ajax({
      url: kpa.ajax_url,
      data: {
        action: "do_filter_posts",
        nonce: kpa.nonce,
        params: $params
      },
      type: "post",
      dataType: "json",
      success: function(data, textStatus, XMLHttpRequest) {
        if (data.status === 200) {
          $container.attr('data-term', data.term);
          $content.html(data.content);
        } else if (data.status === 201) {
          $content.html(data.message);
        } else {
          //$status.html( data.message );
        }
      },
      complete: function(data, textStatus) {
        msg = textStatus;
        if (textStatus === "success") {
          msg = data.found;
        }

        rebind_pagination();

        // are the new history methods available ?
        if (
          window.history != undefined &&
          window.history.pushState != undefined
        ) {

          postType = $params["post_type"];

          if (postType=="post"){
            postType = "resources";
          } else {
            postType = $params["post_type"];
          }

          // Add parameters to URL that just ran in the query
          if ($params["page"] > 1) {
            var term_url = '';
            if ( $params["term"] ){
              term_url = "/"  + $params["term"];
            }

            console.log(postType);
            history.replaceState(
              {},
              "Term: " + $params["term"],
              "/" + postType + term_url + "/page/" + $params["page"]
            );
          } else {
            history.replaceState(
              {},
              "Term: " + $params["term"],
              "/" + postType + "/" + $params["term"]
            );
          }
        }
      },
      error: function(MLHttpRequest, textStatus, errorThrown) {
        console.log('error');
        console.log(MLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
      }
    });
  }

  function rebind_pagination() {
    $('.pagination li a').off('click');
    bind_pagination();
  }

  function bind_pagination() {
    $('.pagination a').on('click', function(e) {
      e.preventDefault();
  
      // Saving dem brackets
      $this = $(this);
  
      // Let's start moving the user to the top of the page now while the query goes down
      scroll_to_posts();
  
      // We need to get the page reference from our clicked pagination nav derrived from the HREF
      $page = parseInt($this.attr("href").replace(/\D/g, ""));
      console.log($page);
  
      // Build our parameters
      $params = {
        tax: $('#ajax-container').data("tax"),
        term: $('#ajax-container').data("term"),
        page: $page,
        post_type: $('#ajax-container').data("post-type"),
        qty: $('#ajax-container').data("paged")
      };
  
      // Run query
      get_posts($params);
    });
  }
});